import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { GuestCountModalComponent } from '../modals/guest-count-modal/guest-count-modal.component';
import { CheckoutItemComponent } from '../components/checkout-item/checkout-item.component';
import { SelectPaymentMethodModalComponent } from '../modals/select-payment-method-modal/select-payment-method-modal.component';
import { InvoiceEmailModalComponent } from '../modals/inoice-email-modal/invoice-email-modal.component';
import { TipSelectorComponent } from '../components/tip-selector/tip-selector.component';
import { CreditCardModalComponent } from '../modals/credit-card-modal/credit-card-modal.component';
import { HeaderComponent } from '../components/header/header.component';
import { InfoRowComponent } from '../components/info-row/info-row.component';
import { CashPaymentModalComponent } from '../modals/cash-payment-modal/cash-payment-modal.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { PaySessionStatisticsComponent } from '../components/pay-session-statistics/pay-session-statistics.component';
import { StatusHeaderComponent } from '../components/status-header/status-header.component';
import { AbsoluteTipInputModalComponent } from '../modals/absolute-tip-input-modal/absolute-tip-input-modal.component';
import { GiftCardModalComponent } from '../modals/gift-card-modal/gift-card-modal.component';
import { PaymentTimeoutModalComponent } from '../modals/payment-timeout-modal/payment-timeout-modal.component';
import { GooglePayModalComponent } from '../modals/google-pay-modal/google-pay-modal.component';
import { SplitChangeBlockedModalComponent } from '../modals/split-change-blocked-modal/split-change-blocked-modal.component';
import { DiscountingBlockedModalComponent } from '../modals/discounting-blocked-modal/discounting-blocked-modal.component';
import { ApplePayModalComponent } from '../modals/apple-pay-modal/apple-pay-modal.component';
import { PaypalModalComponent } from '../modals/paypal-modal/paypal-modal.component';
import { AddGiftCardModalComponent } from '../modals/add-gift-card-modal/add-gift-card-modal.component';
import { TipSelectionModalComponent } from '../modals/tip-selection-modal/tip-selection-modal.component';
import { TopgolfAnimationComponent } from '../components/topgolf-animation/topgolf-animation.component';
import { FeedbackWidgetComponent } from '../components/feedback-widget/feedback-widget.component';

@NgModule({
	imports: [CommonModule, IonicModule, FormsModule, QRCodeComponent, PaySessionStatisticsComponent, NgOptimizedImage, TranslateModule],
	declarations: [
		GuestCountModalComponent,
		CheckoutItemComponent,
		SelectPaymentMethodModalComponent,
		InvoiceEmailModalComponent,
		TipSelectorComponent,
		CreditCardModalComponent,
		GooglePayModalComponent,
		ApplePayModalComponent,
		PaypalModalComponent,
		GiftCardModalComponent,
		HeaderComponent,
		PaymentTimeoutModalComponent,
		InfoRowComponent,
		CashPaymentModalComponent,
		StatusHeaderComponent,
		AbsoluteTipInputModalComponent,
		SplitChangeBlockedModalComponent,
		DiscountingBlockedModalComponent,
		AddGiftCardModalComponent,
		TipSelectionModalComponent,
		TopgolfAnimationComponent,
		FeedbackWidgetComponent,
	],
	exports: [
		TranslateModule,
		GuestCountModalComponent,
		CheckoutItemComponent,
		SelectPaymentMethodModalComponent,
		InvoiceEmailModalComponent,
		TipSelectorComponent,
		CreditCardModalComponent,
		GooglePayModalComponent,
		ApplePayModalComponent,
		PaypalModalComponent,
		GiftCardModalComponent,
		HeaderComponent,
		InfoRowComponent,
		CashPaymentModalComponent,
		QRCodeComponent,
		StatusHeaderComponent,
		AbsoluteTipInputModalComponent,
		PaymentTimeoutModalComponent,
		SplitChangeBlockedModalComponent,
		DiscountingBlockedModalComponent,
		AddGiftCardModalComponent,
		TipSelectionModalComponent,
		TopgolfAnimationComponent,
		FeedbackWidgetComponent,
	],
})
export class SharedModule {}
